/* Oricle content-section behaviours: mobile comparison toggle, product-card specs, the review
   filter, and the lineup's add-to-cart hand-off. */
(() => {
  /* Two-up mobile table: show all models / fewer. */
  class OricleMobileTable extends HTMLElement {
    connectedCallback() {
      if (this._bound) return; this._bound = true;
      this.toggle = this.querySelector('[data-o-mtable-toggle]');
      if (!this.toggle) return;
      this.toggle.addEventListener('click', () => {
        const all = !this.classList.contains('is-all');
        this.classList.toggle('is-all', all);
        this.style.setProperty('--vis', all ? this.dataset.count : 2);
        this.querySelectorAll('[data-col]').forEach((el) => { if (all) el.hidden = false; else if (el.dataset.hiddenDefault === '1') el.hidden = true; });
        this.toggle.textContent = all ? this.toggle.dataset.less : this.toggle.dataset.more;
        this.toggle.setAttribute('aria-expanded', all ? 'true' : 'false');
      });
      this.querySelectorAll('[data-col]').forEach((el) => { if (el.hidden) el.dataset.hiddenDefault = '1'; });
    }
  }
  if (!customElements.get('oricle-mobile-table')) customElements.define('oricle-mobile-table', OricleMobileTable);

  /* Product card: first three specs show; the rest are one tap away. */
  class OricleSpecs extends HTMLElement {
    connectedCallback() {
      if (this._bound) return; this._bound = true;
      const btn = this.querySelector('[data-o-specs-toggle]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.querySelectorAll('.is-extra').forEach((r) => { r.hidden = !open; });
        btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    }
  }
  if (!customElements.get('oricle-specs')) customElements.define('oricle-specs', OricleSpecs);

  /* Reviews: chips filter cards by tag. A card's data-tag is pipe-wrapped (|sound quality|value|)
     and a chip broadcasts one key, so a chip matches a whole key and never a fragment of a longer
     one. A chip that matches nothing shows nothing: the shelf never back-fills the grid with
     reviews that are not about the chip (they would read as if they were). While a chip is on,
     every match shows, including cards still behind "Show more" — the button steps aside and
     returns when the filter clears. "Show more" reveals the remaining reviews a step at a time,
     moves focus to the first newly shown card, updates the "Showing N of M" line and, once nothing
     is left, hides itself and shows the tail (an all-reviews link when one exists). A phone holds
     back more of the shelf than a desktop (.is-extra-m, hidden by CSS below 768px), so the first
     taps there reveal those at the phone's own step. */
  class OricleReviews extends HTMLElement {
    connectedCallback() {
      if (this._bound) return; this._bound = true;
      this.cards = Array.from(this.querySelectorAll('.o-review'));
      this.addEventListener('oricle:filter', (e) => this.filter(e.detail.value));
      const more = this.querySelector('[data-o-reviews-more]');
      if (more) more.addEventListener('click', () => this.more(more));
    }
    filter(value) {
      const v = (value || '').toLowerCase();
      const matched = v ? this.cards.filter((c) => (c.dataset.tag || '').indexOf('|' + v + '|') > -1) : this.cards;
      this.cards.forEach((c) => {
        c.hidden = matched.indexOf(c) === -1 || (!v && c.classList.contains('is-extra') && !c.dataset.shown);
      });
      this.toggleAttribute('data-filtering', !!v);
      const more = this.querySelector('[data-o-reviews-more]');
      if (more && !more.dataset.done) more.hidden = !!v;
    }
    more(btn) {
      const phone = window.matchMedia('(max-width: 767px)').matches;
      // A desktop already shows the phone-only extras; mark them so a later rotate to a phone keeps them.
      if (!phone) this.cards.forEach((c) => { if (c.classList.contains('is-extra-m')) c.dataset.shown = '1'; });
      const step = parseInt(phone && btn.dataset.stepM ? btn.dataset.stepM : btn.dataset.step, 10) || 10;
      const waiting = this.cards.filter((c) => !c.dataset.shown && (c.classList.contains('is-extra') || (phone && c.classList.contains('is-extra-m'))));
      const batch = waiting.slice(0, step);
      batch.forEach((c) => { c.dataset.shown = '1'; c.hidden = false; });
      btn.setAttribute('aria-expanded', 'true');
      const shown = this.querySelector('[data-o-reviews-shown]');
      if (shown) shown.textContent = (shown.dataset.template || '').replace('{shown}', String(this.cards.filter((c) => !c.hidden).length));
      if (waiting.length <= batch.length) {
        btn.dataset.done = '1';
        btn.hidden = true;
        const tail = this.querySelector('[data-o-reviews-tail]');
        if (tail) tail.hidden = false;
      }
      if (batch[0]) batch[0].focus();
    }
  }
  if (!customElements.get('oricle-reviews')) customElements.define('oricle-reviews', OricleReviews);

  /* One delegated listener: the lineup's "Add to cart" on the product page triggers the buy
     form through the shared helper (works before Safari 16, and cannot double-add). */
  document.addEventListener('click', (e) => {
    const lineupAdd = e.target.closest('[data-o-lineup-add]');
    if (!lineupAdd) return;
    if (!(window.Oricle && window.Oricle.submitBuyForm && window.Oricle.submitBuyForm(lineupAdd))) window.location.hash = '#MainContent';
  });
})();

  /* —— FAQ "Show more": reveal the hidden questions, move focus to the first revealed one, retire the control. —— */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-o-faq-more]');
    if (!btn) return;
    const list = document.getElementById(btn.getAttribute('aria-controls'));
    if (!list) return;
    const extra = list.querySelectorAll('.o-faq__extra');
    extra.forEach((item) => item.removeAttribute('hidden'));
    btn.setAttribute('aria-expanded', 'true');
    const first = extra[0] && extra[0].querySelector('[data-o-acc-trigger]');
    if (first) first.focus();
    btn.hidden = true;
  });
